
import RelationSelectBox from "./RelationSelectBox";
import type { Select2WebElementModel } from "./API";

export interface RelationFieldType {
	method?: "post" | "get";
	url: string;
	valueKey: string;
	titleKey?: string;
	filterable?: boolean;
	serverSideSearch?: boolean;
	enablePagination?: boolean;
	onPrepareRequestData?: ( params?: any ) => any;
	onPrepareResponseData?: ( options: Select2WebElementModel[] ) => Select2WebElementModel[];
};

export default RelationSelectBox;
